import article_components from "../articles/drafts/components/metadata";
import article_example from "../articles/drafts/example/metadata";

import article_screen from "../articles/published/2017-04-15--screen/metadata";
import article_shebang from "../articles/published/2017-04-28--shebang/metadata";
import article_cssNamedColors from "../articles/published/2017-05-11--css-named-colors/metadata";
import article_debianPackages from "../articles/published/2017-05-21--debian-packages/metadata";
import article_ajax from "../articles/published/2017-07-11--ajax/metadata";
import article_randomNumbers from "../articles/published/2017-07-17--random-numbers/metadata";
import article_iife from "../articles/published/2017-07-20--iife/metadata";
import article_commonNamingMistakes from "../articles/published/2017-08-24--common-naming-mistakes/metadata";
import article_vim from "../articles/published/2017-12-17--vim/metadata";
import article_switchNodeVersion from "../articles/published/2019-05-13--switch-node-version/metadata";
import article_squashCommits from "../articles/published/2019-08-08--squash-commits/metadata";
import article_helloExtension from "../articles/published/2019-08-25--hello-extension/metadata";
import article_unionTypes from "../articles/published/2019-09-03--union-types/metadata";
import article_restartPostgresql from "../articles/published/2020-06-22--restart-postgresql/metadata";
import article_docker from "../articles/published/2020-09-21--docker/metadata";

export const articlesDrafts = [article_components, article_example];

export const articlesPublished = [
  article_screen,
  article_shebang,
  article_cssNamedColors,
  article_debianPackages,
  article_ajax,
  article_randomNumbers,
  article_iife,
  article_commonNamingMistakes,
  article_vim,
  article_switchNodeVersion,
  article_squashCommits,
  article_helloExtension,
  article_unionTypes,
  article_restartPostgresql,
  article_docker
];
